"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePromocode = usePromocode;
exports["default"] = PromocodeProvider;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _humps = require("humps");

var PromocodeContext = _react["default"].createContext(null);

function usePromocode() {
  var _React$useContext = _react["default"].useContext(PromocodeContext),
      promocodeResponse = _React$useContext.promocodeResponse,
      setPromocodeResponse = _React$useContext.setPromocodeResponse;

  return [promocodeResponse, setPromocodeResponse];
}

function PromocodeProvider(props) {
  var _React$useState = _react["default"].useState(null),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      promocodeResponse = _React$useState2[0],
      setPromocodeResponse = _React$useState2[1];

  return _react["default"].createElement(PromocodeContext.Provider, {
    value: {
      promocodeResponse: promocodeResponse,
      setPromocodeResponse: setPromocodeResponse
    }
  }, props.children);
}